import { Box, withStyles } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';
import { Form } from 'formik';
import styled from 'styled-components';

export const EnhancerFormContainer = withStyles({
  root: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px'
  }
})(Box);

export const EnhancerFormControlsButton = withStyles({
  root: {
    padding: '12px 24px',
    borderRadius: '120px'
  }
})(SButton);

export const EnhancerForm = styled(Form)({
  minWidth: '500px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px'
});
